import {
  getEndOfDay,
  getStartOfDay,
  isValidDate,
  subDays,
  toDate,
} from '@querodelivery/qd-date-helper';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import type { TDeliveryStatus } from '@/Interfaces/Data';
import { queryStringToObject } from '@/Utils/FnUtils';
import { useGetDeliveriesList } from './api/get-deliveries';
import { DeliveriesFilter } from './componentes/filter';
import { DeliveriesList } from './componentes/list';
import { STATUS_OPTIONS, TIME_MILLISECONDS_REFETCH } from './constants';
import type { GetDeliveriesListParams, IQueryString } from './types';
import { useAppSelector } from '@/_store/hooks';

function DeliveriesMain() {
  const location = useLocation();
  const query: IQueryString = queryStringToObject(location.search);
  const [, setSearchParams] = useSearchParams();

  const filteredCityId = useAppSelector(
    state => state.filters.cityIdOnDeliveriesList,
  );
  const filteredDeliveryType = useAppSelector(
    state => state.filters.deliveryTypeOnDeliveriesList,
  );

  useEffect(() => {
    if (filteredCityId) {
      setSearchParams(prev => {
        prev.set('cityId', filteredCityId);
        return prev;
      });
    }

    if (filteredDeliveryType) {
      setSearchParams(prev => {
        prev.set('deliveryType', filteredDeliveryType);
        return prev;
      });
    }
  }, [filteredCityId, filteredDeliveryType]);

  const queryDeliveryStatus = (() => {
    if (query.status) {
      const newStatus = query.status.filter(queryStatus =>
        STATUS_OPTIONS.some(statusOption => statusOption.value == queryStatus),
      ) as Array<TDeliveryStatus>;

      if (!isEmpty(newStatus)) return newStatus;
    }

    return [];
  })();

  const [params, setParams] = useState<GetDeliveriesListParams>({
    placeId: query.placeId || '',
    placeName: query.placeName || '',
    motoboyId: query.motoboyId || '',
    motoboyName: query.motoboyName || '',
    code: query.code || '',
    deliveryId: query.deliveryId || '',
    cityId: filteredCityId || query.cityId || '',
    startDate:
      query.startDate && isValidDate(new Date(query.startDate))
        ? toDate(query.startDate)
        : getStartOfDay(subDays(toDate(), 1)),
    endDate:
      query.endDate && isValidDate(toDate(query.endDate))
        ? toDate(query.endDate)
        : getEndOfDay(toDate()),
    status: queryDeliveryStatus,
    deliveryType: filteredDeliveryType || query.deliveryType || '',
    billingType: query.billingType || '',
  });
  const [page, setPage] = useState(1);

  const { data, isLoading } = useGetDeliveriesList(
    {
      ...params,
      page,
    },
    {
      refetchIntervalInBackground: true,
      refetchInterval: TIME_MILLISECONDS_REFETCH,
    },
  );

  return (
    <div>
      <DeliveriesFilter
        setParams={setParams}
        setPage={setPage}
        params={params}
        isLoading={isLoading}
      />
      <DeliveriesList
        isLoading={isLoading}
        data={data}
        page={page}
        setPage={setPage}
      />
    </div>
  );
}

export { DeliveriesMain };
